export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  tags: string[];
  image: string;
  author: string;
  publishDate: string;
  readCount: string;
  commentCount: string;
  isHot: boolean;
  isExclusive: boolean;
  isVideo: boolean;
}

export const articles: Article[] = [
  {
    slug: 'dingliu-nanyixing-pijing-shangye-diguo',
    title: '顶流男艺人被曝私下经营庞大商业帝国，年收入超十位数引争议',
    excerpt: '据知情人士透露，该艺人名下关联公司多达37家，涉及餐饮、潮牌、直播等多个领域，但其个人品牌多次被消费者投诉质量问题。',
    content: `<p>近日，一位不愿透露姓名的业内人士向本网爆料，当前娱乐圈某顶流男艺人私下实际掌控着一个庞大的商业帝国。</p><p>据调查，该艺人名下关联公司多达37家，涵盖餐饮连锁、潮流服饰、MCN直播机构、影视投资等多个领域。其中最为引人注目的是其完全控股的一家文化传媒公司，去年营收据称突破30亿元人民币。</p><p>然而，伴随着商业版图的快速扩张，问题也随之而来。多个消费者维权平台显示，该艺人旗下潮牌服饰多次被投诉"实物与宣传严重不符"，其投资的餐饮品牌也曾因食品安全问题被监管部门约谈。</p><p>一位娱乐产业分析师表示："现在很多艺人都开始涉足商业，但很少有人能做到如此规模。关键是商业扩张的同时，品牌信誉和产品质量能否跟上，这是最大的考验。"</p><p>截至发稿前，该艺人工作室尚未对此事做出回应。业内人士分析认为，此事若持续发酵，可能影响其多个代言合同的续约。</p><p>我们将持续关注此事的后续发展。</p>`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    tags: ['顶流', '商业帝国', '争议', '代言'],
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20entertainment%20industry%20backdrop%2C%20luxurious%20golden%20and%20dark%20amber%20color%20palette%2C%20blurred%20business%20empire%20visual%20metaphor%2C%20paparazzi%20flash%20style%2C%20rich%20warm%20tones%2C%20editorial%20magazine%20photography%2C%20cinematic%20mysterious%20atmosphere&width=1200&height=675&seq=article-dingliu&orientation=landscape',
    author: '黑料调查组',
    publishDate: '2026-07-06',
    readCount: '1.2M',
    commentCount: '8.9K',
    isHot: true,
    isExclusive: true,
    isVideo: false,
  },
  {
    slug: 'danghong-xiaohua-duijiao-benzou-zhenxiang',
    title: '当红小花被曝片场耍大牌，对戏演员崩溃离场真相',
    excerpt: '现场工作人员爆料，该女星多次迟到并拒绝配合拍摄，导致剧组损失惨重。与其搭档的男演员因无法忍受最终愤然离场。',
    content: `<p>近日，某古装剧剧组工作人员向本网独家爆料，该剧女一号——一位近期热度极高的当红小花，在拍摄期间多次出现不专业行为。</p><p>据爆料人描述，该女星在为期三个月的拍摄周期内，累计迟到超过200小时。更为严重的是，她多次以"状态不好"为由拒绝拍摄重头戏，导致剧组整体进度延误近一个月。</p><p>最令人震惊的一次事件发生在上月，该女星因私人行程临时取消全天拍摄，与其对戏的男演员在片场等待8小时后，最终情绪崩溃愤然离场。现场目击者称："那位男演员平时脾气很好，但那天真的被气到浑身发抖。"</p><p>据保守估算，因该女星个人行为导致的剧组直接经济损失超过800万元。制片方多次与其经纪公司沟通，但收效甚微。</p><p>记者就此事联系该女星工作室，对方以"不便回应"为由挂断电话。圈内人士表示，类似情况在娱乐圈并非个例，但如此严重的实属罕见。</p>`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    tags: ['耍大牌', '片场', '损失', '小花'],
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20film%20set%20backdrop%2C%20warm%20amber%20and%20deep%20coral%20lighting%2C%20blurred%20movie%20production%20scene%2C%20tension%20and%20drama%20atmosphere%2C%20editorial%20style%2C%20cinematic%20lighting%2C%20rich%20warm%20tones&width=1200&height=675&seq=article-xiaohua&orientation=landscape',
    author: '片场直击',
    publishDate: '2026-07-05',
    readCount: '980K',
    commentCount: '12.3K',
    isHot: true,
    isExclusive: true,
    isVideo: false,
  },
  {
    slug: 'yixian-wanghong-zhibo-fanche-shilu',
    title: '一线网红直播翻车全记录：假货风波后粉丝暴跌300万',
    excerpt: '拥有千万粉丝的带货女王在直播中被网友当场揭穿售卖假货，事后的公关操作更是令人瞠目结舌。',
    content: `<p>拥有超过2000万粉丝的知名带货网红"糖糖"上周在直播间遭遇了职业生涯最大的翻车事件。</p><p>据悉，当晚直播间观看人数峰值达180万人，糖糖正在推介一款自称"品牌直供"的高端护肤品。然而，一位自称该品牌前员工的网友在弹幕中当众揭穿，称该产品包装与正品存在多处差异，并晒出对比照片。</p><p>面对突如其来的质疑，糖糖的临场反应令人失望。她先是强硬否认，随后在越来越多的用户晒出假货对比图后，情绪失控摔掉产品并直接关闭了直播。</p><p>事件发酵后，多个消费者在社交平台晒出从糖糖直播间购买的问题产品。更有网友深扒发现，其团队注册的供应链公司曾被市场监管部门处罚过。三天之内，糖糖的粉丝数暴跌超过300万。</p><p>目前，多个品牌方已宣布暂停与糖糖的合作。市场监管局也回应称已关注此事并介入调查。这一事件再次引发公众对直播带货行业监管的关注。</p>`,
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    tags: ['直播翻车', '假货', '掉粉', '带货'],
    image: 'https://readdy.ai/api/search-image?query=Abstract%20live%20streaming%20studio%20backdrop%2C%20warm%20coral%20and%20deep%20rose%20gradient%2C%20digital%20screen%20glow%20effect%2C%20dramatic%20atmosphere%2C%20social%20media%20crisis%20vibe%2C%20editorial%20photography%2C%20rich%20warm%20tones%20with%20dramatic%20lighting&width=1200&height=675&seq=article-wanghong&orientation=landscape',
    author: '直播观察员',
    publishDate: '2026-07-04',
    readCount: '1.5M',
    commentCount: '15.7K',
    isHot: true,
    isExclusive: false,
    isVideo: true,
  },
  {
    slug: 'zongyi-jie-mu-zu-ju-qian-gui-ze',
    title: '某选秀综艺被曝选手晋级全靠钱，制作方内部文件流出',
    excerpt: '一份疑似内部晋级费用表在网络疯传，不同名次对应不同金额的"赞助费"，最高达七位数。',
    content: `<p>近日，一份据称来自某大型选秀综艺节目制作方内部的文件在网络上广泛传播，引发公众对选秀节目公平性的强烈质疑。</p><p>根据这份文件显示，该节目的选手晋级存在一套明码标价的"赞助费"体系。其中，进入全国50强需缴纳"培训赞助费"50万元，进入20强则上升到150万元，而想要确保进入总决赛，费用高达500万元。</p><p>文件还详细列出了不同名次对应的"资源包"，包括节目镜头时长、推广资源、后续商演机会等，全部明码标价。一位业内人士向本网证实了该文件的真实性，并透露："这其实是行业公开的秘密，只是金额大小有差别。"</p><p>截至目前，该节目制作方发布声明称文件系"恶意伪造"，并表示已向公安机关报案。但多位参赛选手的粉丝注意到，节目开播以来，确实存在一些实力不俗但"莫名其妙"被淘汰的选手。</p><p>文化和旅游部相关部门表示，将对此类选秀节目的运作机制进行调查，维护文化市场的公平公正。</p>`,
    category: '综艺内幕',
    categorySlug: 'zongyi-neimu',
    tags: ['选秀', '晋级', '赞助费', '公平性'],
    image: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20talent%20show%20stage%20backdrop%2C%20warm%20golden%20spotlights%2C%20dramatic%20theatrical%20lighting%2C%20mysterious%20behind%20the%20scenes%20vibe%2C%20entertainment%20industry%20aesthetic%2C%20editorial%20photography%2C%20rich%20amber%20and%20coral%20tones&width=1200&height=675&seq=article-zongyi&orientation=landscape',
    author: '综艺大揭秘',
    publishDate: '2026-07-03',
    readCount: '890K',
    commentCount: '10.2K',
    isHot: false,
    isExclusive: true,
    isVideo: false,
  },
  {
    slug: 'dianying-juxing-pian-chou-baoguang',
    title: '电影巨星实际片酬曝光，对外宣称数字竟缩水三倍',
    excerpt: '税务文件意外流出，某功夫巨星的真实片酬与对外宣传存在巨大差异。业内人士揭秘片酬"注水"产业链。',
    content: `<p>一份意外的税务文件让娱乐圈片酬"注水"的潜规则浮出水面。据文件显示，某国际知名的功夫巨星，其一部大制作电影的实际片酬为2800万元，而对外宣传的数字却高达8000万元，两者相差近三倍。</p><p>娱乐行业分析师李明（化名）解释称："片酬注水是行业的普遍操作。一方面，高片酬能提升艺人的商业价值和行业地位；另一方面，制作方也能借此提高项目的融资能力和市场预期。"</p><p>然而，这种操作也带来了诸多问题。过高的"宣传片酬"抬高了整个行业的价格基准，导致中小成本电影的制作压力越来越大。更重要的是，当真实数字曝光后，对艺人和项目的信誉都会造成损害。</p><p>知情人士透露，该巨星方面对此事保持沉默，但已通过律师向相关部门提交了文件泄露的调查申请。有观点认为，这次泄露可能涉及到娱乐圈内部的竞争博弈。</p>`,
    category: '影视黑料',
    categorySlug: 'yingshi-heiliao',
    tags: ['片酬', '注水', '巨星', '税务'],
    image: 'https://readdy.ai/api/search-image?query=Abstract%20luxury%20film%20industry%20backdrop%2C%20warm%20golden%20and%20deep%20amber%20color%20palette%2C%20cinematic%20movie%20set%20atmosphere%2C%20dramatic%20lighting%2C%20editorial%20photography%20style%2C%20rich%20warm%20tones%2C%20mysterious%20Hollywood%20vibe&width=1200&height=675&seq=article-pianchou&orientation=landscape',
    author: '数据挖掘组',
    publishDate: '2026-07-02',
    readCount: '756K',
    commentCount: '6.5K',
    isHot: false,
    isExclusive: true,
    isVideo: false,
  },
  {
    slug: 'geshou-chaoxi-fengbo-zui-xin-jinzhan',
    title: '知名歌手新歌被指抄袭，原作者跨国起诉索赔千万',
    excerpt: '音乐制作人指出某热门歌曲与一首三年前的英文单曲高度相似，旋律重合度高达87%。原作者已正式提起诉讼。',
    content: `<p>一场跨国音乐抄袭风波正在持续发酵。国内某知名歌手去年发布的热门单曲《星光》，被指与美国独立音乐人John Martinez三年前发布的《Starlight》高度相似。</p><p>专业音乐分析机构出具的报告显示，两首歌曲在旋律走向、和声编排以及副歌结构上的重合度高达87%。音乐制作人张伟在社交平台发文称："这已经不是借鉴的范畴了，副歌部分几乎是一模一样的。"</p><p>John Martinez的律师团队已于上周正式向法院提起诉讼，指控该歌手及其唱片公司侵犯著作权，索赔金额高达120万美元（约合人民币870万元）。起诉书中详细列出了两首歌的谱面对比和技术分析报告。</p><p>该歌手工作室发布声明称，歌曲系独立创作完成，"不存在任何抄袭行为"，并表示将积极应诉。但多位音乐业内人士私下向本网透露，这种情况在行业内并不少见，大多数案例最终以庭外和解收场。</p>`,
    category: '音乐圈',
    categorySlug: 'yinle-quan',
    tags: ['抄袭', '跨国诉讼', '索赔', '原创'],
    image: 'https://readdy.ai/api/search-image?query=Abstract%20music%20studio%20backdrop%2C%20warm%20amber%20and%20deep%20coral%20lighting%2C%20recording%20equipment%20blurred%2C%20dramatic%20legal%20drama%20atmosphere%2C%20editorial%20photography%20style%2C%20rich%20warm%20tones%2C%20cinematic%20composition&width=1200&height=675&seq=article-chaoxi&orientation=landscape',
    author: '乐评人专栏',
    publishDate: '2026-07-01',
    readCount: '680K',
    commentCount: '7.8K',
    isHot: true,
    isExclusive: false,
    isVideo: false,
  },
  {
    slug: 'wanghong-qinglv-fenshou-neimu',
    title: '网红情侣分手内幕：男方出轨截图被扒，女方直播痛哭',
    excerpt: '拥有500万粉丝的情侣档突然宣布分手，随后大量男方出轨证据被网友扒出，事件持续升级。',
    content: `<p>全网关注的网红情侣"小鹿&阿杰"突然宣布分手的消息登上了热搜榜首。这对在短视频平台拥有超过500万粉丝的情侣，一直以来都是网友眼中的模范情侣，突然的分手声明让粉丝们措手不及。</p><p>然而，真正引发舆论风暴的是随后被网友扒出的一系列证据。多位自称知情人士的网友陆续发布了阿杰与其他女性的暧昧聊天截图、深夜出入酒店的照片，以及多条来自不同女性的爆料信息。</p><p>最令人心碎的一幕发生在昨晚，小鹿在个人直播中谈及此事时情绪崩溃，数度哽咽无法继续。她在直播中说："我以为我们的感情是真的，但原来在镜头之外的他是完全另一个人。"该直播观看人数峰值突破200万。</p><p>目前，阿杰方面已关闭了个人社交账号的评论功能，尚未做出任何正式回应。而其商业合作伙伴也纷纷开始与其切割，多个品牌宣布暂停合作。</p>`,
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    tags: ['情侣', '出轨', '分手', '直播痛哭'],
    image: 'https://readdy.ai/api/search-image?query=Abstract%20emotional%20breakup%20themed%20backdrop%2C%20warm%20rose%20and%20deep%20coral%20gradient%2C%20soft%20dramatic%20lighting%2C%20romantic%20but%20melancholic%20atmosphere%2C%20editorial%20photography%20style%2C%20rich%20warm%20tones%2C%20cinematic%20composition&width=1200&height=675&seq=article-qinglv&orientation=landscape',
    author: '情感观察室',
    publishDate: '2026-06-30',
    readCount: '1.1M',
    commentCount: '13.4K',
    isHot: true,
    isExclusive: false,
    isVideo: true,
  },
  {
    slug: 'zongyi-daoju-zu-jia-qiao-men',
    title: '综艺节目道具组造假揭秘：那些让你泪目的桥段都是演的',
    excerpt: '一位曾在多档热门综艺工作的道具师匿名爆料，节目中的感人故事80%都是编造的，连"素人"都是演员扮演。',
    content: `<p>"我在这个行业做了六年，参与了不下十档热门综艺的制作。"一位选择匿名接受采访的道具师小王对本网说，"我可以负责任地告诉你们，你们在电视上看到的那些让人泪流满面的故事，80%都是编剧写出来的。"</p><p>小王揭露了综艺节目中的多种造假手段。首先，所谓的"素人嘉宾"其实大多是经过筛选的素人演员或者是不知名的十八线艺人。其次，节目中的冲突、感动、和好等情节，都有详细的剧本和走位安排。甚至那些看似真实的"偷拍"画面，也都是多机位精心拍摄的。</p><p>"有一次我们做一档相亲节目，所谓的男女嘉宾其实各自都有对象，来录节目就是为了拿通告费和曝光度。"小王说，"他们在节目上牵手成功，下了节目各回各家，连联系方式都没留。"</p><p>记者调查发现，目前国内综艺市场上存在一条完整的"造假产业链"，从素人演员供应、编剧外包到后期剪辑，每个环节都有专门的团队负责。</p>`,
    category: '综艺内幕',
    categorySlug: 'zongyi-neimu',
    tags: ['造假', '道具组', '剧本', '素人演员'],
    image: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20production%20backstage%20backdrop%2C%20warm%20golden%20and%20amber%20lighting%2C%20props%20and%20equipment%20blurred%2C%20behind%20the%20scenes%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20rich%20warm%20tones%2C%20cinematic%20composition&width=1200&height=675&seq=article-daoju&orientation=landscape',
    author: '综艺揭秘局',
    publishDate: '2026-06-29',
    readCount: '620K',
    commentCount: '9.1K',
    isHot: false,
    isExclusive: true,
    isVideo: true,
  },
];